export const GET_STATE_PHYSICAL_SUCCESS = 'GET_STATE_PHYSICAL_SUCCESS'

export const getStatePhysicalSuccess = (value) => {
  return {
    type: GET_STATE_PHYSICAL_SUCCESS,
    data: value,
  }
}
